"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkService = void 0;
const LangUtil_1 = require("../../base/cutil/LangUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const qs_1 = __importDefault(require("qs"));
class LinkService {
    constructor(brainClient, meStore) {
        this.brainClient = brainClient;
        this.meStore = meStore;
    }
    structureLinkParameters(params) {
        const previewV2 = params.enablePreviewApp === true
            ? {
                type: params.type,
                appId: params.appId,
                uuid: params.uuid,
            }
            : {};
        const legacyProjectAttrIndexer = { legacy_project_attr_indexer: params.legacy_project_attr_indexer } || {};
        const queryParameters = {
            stripePaymentActivated: (0, is_blank_1.default)(params.stripe_price_id) === false ? false : undefined,
            selectedUI: params.selectedUI,
            ...previewV2,
            ...legacyProjectAttrIndexer,
        };
        // if (params.legacy_project_attr_indexer) {
        //   const legacy_project_attr_indexer = params.legacy_project_attr_indexer;
        // }
        return qs_1.default.stringify(queryParameters, { skipNulls: true });
    }
    structureUrl(index, parameters) {
        const newUrl = `${window.location.origin}${window.location.pathname}#/editor`;
        const link = `${newUrl}/shared_intelligent_app/${index}?${parameters}`;
        return link;
    }
    async generateLink(params) {
        const parameters = this.structureLinkParameters(params.structureLinkParams);
        const url = this.structureUrl(params.index, parameters);
        const linkData = {
            $web_only: true,
            $fallback_url: url,
        };
        const result = await (0, LangUtil_1.tryPromise)(this.brainClient.openAi.dynamicLinkV2(linkData));
        return result.data?.data?.dynamiclink || url;
    }
}
exports.LinkService = LinkService;
